import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseService } from '@morningstar/shared/base/base-service';
import { HelpVideo } from 'apps/wsg/src/app/admin/help-video/help-video';
import { Observable, EMPTY } from 'rxjs';
import { environment } from '@morningstar/shared/environment';
import { catchError, finalize } from 'rxjs/operators';

@Injectable()
export class HelpVideoIconService extends BaseService {

  constructor(private httpClient: HttpClient, snackbar: MatSnackBar,
              @Inject('API_BASE_URL') private baseUrl: string) {
    super(snackbar);
  }

  getVideo(name: string): Observable<HelpVideo> {
    this.setProcessing(true);
    return this.httpClient.get<HelpVideo>(`
      ${this.baseUrl}${environment.api.helpVideo.getByName.replace('{name}', name)}
    `).pipe(
      catchError(error => {
        this.setSnackbarMessage('Error retrieving video');
        return EMPTY;
      }),
      finalize(() => this.setProcessing(false))
    );
  }
}
